import axios from '@/axios'

// Education stages

export async function listEducationStages (educationSystemId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/education-systems/' + educationSystemId + '/stages')
  return response.data.data
}

export async function newEducationStage (educationSystemId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/education-systems/' + educationSystemId + '/stages', data)
  return response.data.data
}

export async function getEducationStages (educationStageId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/education-stages/' + educationStageId)
  return response.data.data
}

export async function updateEducationStage (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/education-stages/' + id, data)
  return response.data.data
}

export async function deleteEducationStage (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/education-stages/' + id)
  return response.data.data
}

export default {
  listEducationStages,
  newEducationStage,
  getEducationStages,
  updateEducationStage,
  deleteEducationStage
}
